module.exports = __webpack_public_path__ + "img/transparent-white.782e90a4.png";